import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { cn } from '@/lib/utils';

interface SelectableItemProps {
  id: number;
  name: string;
  color?: string;
  isSelected: boolean;
  onSelect: (id: number) => void;
  onEdit?: (id: number) => void;
  onDelete?: (id: number) => void;
  className?: string;
}

export const SelectableItem: React.FC<SelectableItemProps> = ({
  id,
  name,
  color,
  isSelected,
  onSelect,
  className
}) => {
  const handleCheckboxChange = () => {
    onSelect(id);
  };

  return (
    <div
      className={cn(
        "flex items-center gap-2 px-2 py-1.5 rounded-md cursor-pointer",
        isSelected ? "bg-accent/30" : "hover:bg-accent/10",
        className
      )}
      onClick={() => onSelect(id)}
    >
      <Checkbox
        checked={isSelected}
        onCheckedChange={() => handleCheckboxChange()}
        onClick={(e) => e.stopPropagation()}
        className="h-4 w-4"
      />

      {color && (
        <div
          className="w-2 h-2 rounded-full flex-shrink-0"
          style={{ backgroundColor: color }}
        />
      )}

      <span className="text-sm truncate">{name}</span>
    </div>
  );
};
